import api from '../utils/api';

const WaitlistActions = {
  startWaitlist(listingAlias, customerId) {
    return (dispatch) =>
      dispatch(api.waitlist.startWaitlist(listingAlias, customerId))
        .then((result) => {
          if (!result.success) {
            return Promise.reject(result.error.message);
          }
          return Promise.resolve(result.response);
        })
        .catch((err) => Promise.reject(err.message));
  },
  endWaitlist(listingAlias, customerId) {
    return (dispatch) =>
      dispatch(api.waitlist.endWaitlist(listingAlias, customerId))
        .then((result) => {
          if (!result.success) {
            return Promise.reject(result.error.message);
          }
          return Promise.resolve(result.response);
        })
        .catch((err) => Promise.reject(err.message));
  },
};

export default WaitlistActions;
